import { picturePostedApi } from "@/apis/apis";
import { FILTER_TYPE } from "@/constant/constants";
import { booleanOptionFilters } from "@/constant/GeneralOptions/boolean";
import { columns } from "./Columns";
import BaseTable from "./BaseTable";

export default function PicturePostedPage() {
  // const booleanOptionFiltersMap = booleanOptionFilters();
  // const roleTypeFiltersMap = roleTypeFilters();
  // const additionalFilters = [
  //   {
  //     id: "filter[type]",
  //     label: "Type",
  //     type: FILTER_TYPE.SELECT,
  //     options: roleTypeFiltersMap,
  //   },
  //   {
  //     id: "filter[newsletter_subscription]",
  //     label: "Newsletter?",
  //     type: FILTER_TYPE.SELECT,
  //     options: booleanOptionFiltersMap,
  //   },
  //   {
  //     id: "filter[term_conditions_accepted_at]",
  //     label: "T&C?",
  //     type: FILTER_TYPE.SELECT,
  //     options: booleanOptionFiltersMap,
  //   },
  //   {
  //     id: "filter[privacy_policy_accepted_at]",
  //     label: "Privacy Policy?",
  //     type: FILTER_TYPE.SELECT,
  //     options: booleanOptionFiltersMap,
  //   },
  // ];

  return (
    <BaseTable
      label="Picture Posted"
      apiURL={picturePostedApi}
      columns={columns()}
      enableAdd={false}
      enableStatus={false}
    />
  );
}
